import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { forgetPassword } from '../../store/actions/authActions';
import { getContentKeyAccToLang } from '../../utils/utils';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const { authContent } = useSelector((state) => state.content);
  const { userName, authLoading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_forget_screen?.data?.attributes, key, isArabic);
  };

  const handleForgetPassword = (values) => {
    const apiData = {
      UserName: values?.username,
      LanguageId: isArabic ? 4 : 3,
    };
    dispatch(forgetPassword(apiData, navigate));
  };

  return {
    TextWeight,
    isArabic,
    userName,
    authLoading,
    handleForgetPassword,
    navigate,
    getContentKey,
  };
};
